export default "__VITE_PUBLIC_ASSET__fa757b88__"